import { API_PROJECTS, API_THINGS, AUTH_BEARER } from "../constants";
import { axiosDelete, axiosGet, axiosPatch, axiosPost, getAuthorization } from "../utils/axios";


const ProjectApi = {
  getProjects: async (paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(API_PROJECTS, { ...paginationParams }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getProjects:", error);
        return error.response.data;

      });
  },

  getProject: async (projectId: string) => {
    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_PROJECTS}/${projectId}`, {}, headers)
      .then((res) => res.data.data)
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || error.message || "Unknown error";

        console.error("Error getProject:", errorMessage);
        return "error";
      });
  },

  getAllProject: async () => {
    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_PROJECTS}/list`, {}, headers)
      .then((res) => res.data.data)
      .catch((error) => {
        console.error("Error getAllProject:", error);
        return error.response.data;
      });
  },

  createProject: async (name: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPost(API_PROJECTS, { 'name': name }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createProject:", error);
        return error.response.data;
      });
  },

  updateProject: async (projectId: string, name: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPatch(`${API_PROJECTS}/${projectId}`, { 'name': name }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error updateProject:", error);
        return error.response.data;
      });
  },

  deleteProject: async (projectId: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_PROJECTS}/${projectId}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteProject:", error);
        return error.response.data;
      });
  },

  getProjectThings: async (projectId: string, paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}`, { projectId, ...paginationParams }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getProject:", error);
        return error.response.data;
      });
  },

};

export default ProjectApi;
